import styled from 'styled-components';
import filter_arrow from '../../../assets/image/filter_arrow.png';
import filter_arrow_selected from '../../../assets/image/filter_arrow_selected.png';
import sort_arrow_up from '../../../assets/image/sort_arrow_up.png';
import sort_arrow_down from '../../../assets/image/sort_arrow_down.png';
import default_sort_arrow from '../../../assets/image/default_sort_arrow.png';

const Container = styled.div`
position: relative;
width: 100%;
z-index: 234 !important;
height: 1.2rem;
background-color:#fff;
display: flex;
z-index: 100;
&.fixed {
position: fixed;
top: 0;
left: 0;
right: 0;
}
.condition-item {
position: absolute;
top: 1.2rem;
left: 0;
right: 0;
}
`

const ItemContainer = styled.div`
position: relative;
width: 25%;
height: 100%;
display: flex;
align-items: center;
justify-content: center;
.filter-content {
display: flex;
height: 100%;
align-items: center;
max-width: 80%;
overflow: hidden;
white-space:nowrap;
word-break: break-all;
overflow: hidden;
text-overflow: ellipsis;
font-size: 0.28rem;
color: #0b1b2f;
margin-right: .08rem;
&.actived {
color: #cc2729;
}
.selected_filter_indicator {
color: #cc2729;
}
.filter_sort_top {
display: inline-block;
width: 0.20rem;
height: 0.22rem;
background: url("${sort_arrow_up}") no-repeat;
background-size: auto 100%;
}
.filter_sort_down{
display: inline-block;
width: 0.20rem;
height: 0.22rem;
background: url("${sort_arrow_down}") no-repeat;
background-size: auto 100%;
}
}

.filter_sort_default{
display: inline-block;
width: 0.20rem;
height: 0.22rem;
background: url("${default_sort_arrow}") no-repeat;
background-size: auto 100%;
}

.filter-indicator {
display: inline-block;
width: 0.18rem;
height: 0.12rem;
background: url("${filter_arrow}") no-repeat;
background-size: .18rem .12rem;
&.actived {
background: url("${filter_arrow_selected}") no-repeat;
background-size: .18rem .12rem;
}
}
`

const SortContainer = styled.div`
background-color:#fff;
ul {
li {
font-size: .3rem;
padding: .24rem .2rem;
border-bottom: 1px solid #f3f4f5;
letter-spacing: .01rem;
&.actived {
color: #cc2729;
}
}
}
`

const ClassifyContainer = styled.div`
background-color:#fff;
.classify-content {
padding: 0 .2rem;
display: flex;
flex-wrap: wrap;
margin-right: -0.36rem;
.classify-item {
font-size: .3rem;
width: 1.45rem;
margin-right: 0.36rem;
padding: .13rem 0.05rem;
background-color: #f7f8fb;
border-radius: 0.03rem;
margin-bottom: .3rem;
display: flex;
justify-content: center;
align-items: center;
text-align:center;
font-size: 0.24rem;
line-height: .34rem;
color: #1c2030;
&.actived {
background-color: #cc2729;
color: #fff;
}
}
.none {
border: none;
background: rgba(0,0,0,0);
}
}
`

const LocationContainer = styled.div`
-webkit-overflow-scrolling: touch;
height: 8.6rem;
background-color:#f7f8fb;
.province-container {
height: 100%;
position: absolute;
overflow-y: scroll;
overflow-x: hidden;
.province-item {
height: .96rem;
line-height: .96rem;
padding-left: .4rem;
font-size: 0.3rem;
color: #0b1b2f;
&.active {
background-color:#fff;
color: #1265e9;
}
}
}

.city-container {
background-color:#fff;
width: 100%;
height: 100%;
position: absolute;
left: 1.8rem;
overflow-y: scroll;
overflow-x: hidden;
font-size: 0.3rem;
.city-item {
height: .96rem;
line-height: .96rem;
padding-left: .4rem;
&.active {
background-color:#fff;
color: #1265e9;
}
}
}

.county-container {
width: 100%;
height: 100%;
position: absolute;
left: 3.6rem;
overflow-y: scroll;
overflow-x: hidden;
font-size: 0.3rem;
.county-item {
height: .96rem;
line-height: .96rem;
padding-left: .4rem;
&.active {
background-color:#fff;
color: #1265e9;
}
}
}
`

const MoreContainer = styled.div`
font-size: .3rem;
background-color:#fff;
.title-card {
padding: 0 .3rem;
.title{
font-size: 0.28rem;
color: rgba(11, 27, 47, .6);
letter-spacing: .02rem;
margin-bottom: .3rem;
}
.content {
display: flex;
flex-wrap: wrap;
margin-right: -0.36rem;
.filter-item {
display: flex;
justify-content: center;
align-items: center;
margin-bottom: .3rem;
width: 1.45rem;
margin-right: 0.36rem;
line-height: 0.34rem;
background-color: #f7f8fb;
border-radius: 0.03rem;
font-size: 0.24rem;
padding: .13rem .05rem;
color: #1c2030;
&.actived {
background-color: #cc2729;
color: #fff;
}
&.empty {
background-color:#fff;
}
}
}

.price-filter {
display: flex;
justify-content: space-between;
align-items: center;
.line {
width: 0.3rem;
height: 0.02rem;
background-color: #cbcdd3;
}
.price-filter-item {
width: 3rem;
height: 0.68rem;
background-color: #f7f8fb;
border-radius: 0.06rem;
display: flex;
align-items: center;
padding-left: .48rem;
padding-right: .1rem;
input {
width: 100%;
height: 100%;
background-color: rgba(0,0,0,0);
  font-size: 0.26rem;
letter-spacing: 0.01rem;
color: #1c2030;
&::placeholder {
color: #bebec0;
}
}
}
}
}

.group-container {
height: 0.96rem;
margin-top: .6rem;
display: flex;
.btn-item {
flex: 1;
display: flex;
justify-content: center;
align-items: center;
font-size: 0.3rem;
color: #0b1b2f;
}
.reset {}
.confirm{
background-color: #1265e9;
color: #fff;
}
}
`
export {
Container,
ItemContainer,
SortContainer,
ClassifyContainer,
LocationContainer,
MoreContainer,
}
